import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import ContentDuplicate from 'material-ui/svg-icons/content/content-copy';
import FlatButton from "material-ui/FlatButton";

const styles = {
    button: {overflow: 'inherit'},
};

const DuplicateTextButton = ({
                                    basePath = '',
                                    record = {},
                                }) => (
    <FlatButton
        primary
        label='Duplicate'
        icon={<ContentDuplicate/>}
        containerElement={
            <Link to={`${basePath}/create?duplicate=${(record) ? record.id : ''}&type=${encodeURIComponent((record) ? record.type : '')}`}/>
        }
        style={styles.button}
    />
);

DuplicateTextButton.propTypes = {
    basePath: PropTypes.string,
    record: PropTypes.object,
};

DuplicateTextButton.defaultProps = {
    style: {padding: 0},
};

export default DuplicateTextButton;



// WEBPACK FOOTER //
// ./src/Fuse/buttons/DuplicateTextButton.js